<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <template v-if="signIn">
        <el-breadcrumb-item>市场开发</el-breadcrumb-item>
        <el-breadcrumb-item>签到管理</el-breadcrumb-item>
      </template>
      <template v-else-if="isScore">
        <el-breadcrumb-item>评价系统</el-breadcrumb-item>
        <el-breadcrumb-item>成绩查询</el-breadcrumb-item>
      </template>
      <template v-else>
        <el-breadcrumb-item>市场开发</el-breadcrumb-item>
        <el-breadcrumb-item>报名信息</el-breadcrumb-item>
      </template>

    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>

    <!-- 筛选 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span>项目信息筛选</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        class="filter_Form"
        label-width="70px"
        ref="queryFormRef"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="项目名称" prop="name">
              <el-input
                v-model="queryForm.name"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <template v-if="signIn && !isScore">
            <el-col :span="6">
              <el-form-item label="签到状态" prop="signStatus">
                <el-select v-model="queryForm.signStatus" placeholder="全部" style="width: 100%">
                  <el-option label="已签到" :value="true"></el-option>
                  <el-option label="未签到" :value="false"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="审核状态" prop="status">
                <el-select v-model="queryForm.status" placeholder="全部" style="width: 100%">
                  <el-option label="待审核" :value="0"></el-option>
                  <el-option label="通过" :value="1"></el-option>
                  <el-option label="驳回" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="支付状态" prop="paydStatus">
                <el-select v-model="queryForm.paydStatus" placeholder="全部" style="width: 100%">
                  <el-option label="已支付" :value="true"></el-option>
                  <el-option label="待支付" :value="false"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="支付方式" prop="paydType">
                <el-select v-model="queryForm.paydType" placeholder="全部" style="width: 100%">
                  <el-option label="统一支付" :value="1"></el-option>
                  <el-option label="队员自行支付" :value="2"></el-option>
                  <el-option label="线下支付" :value="3"></el-option>
                  <el-option label="F码" :value="4"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资料审核" prop="fileStatus">
                <el-select v-model="queryForm.fileStatus" placeholder="全部" style="width: 100%">
                  <el-option label="待审核" :value="0"></el-option>
                  <el-option label="通过" :value="1"></el-option>
                  <el-option label="驳回" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </template>
          <el-col :span="signIn ? 12 : 18" align="right">
            <el-button
            type="primary"
            @click="getDataList('search')"
          >查询</el-button>
          <el-button type="primary" plain @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <!-- 列表 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="12">
          <span>项目信息列表</span>
        </el-col>
        <el-col :span="12" align="right" v-if="!signIn && !isScore">
          <el-button type="primary" plain size="small" @click="exportListFn">导出报名信息</el-button>
          <el-button type="primary" plain size="small" @click="exportUserFn">导出战队成员</el-button>
        </el-col>
      </el-row>
      <!-- <el-checkbox v-model="signIn">只查看签到信息</el-checkbox> -->
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        border
        stripe
      >
        <el-table-column type="expand" width="50">
          <template slot-scope="props">
            <div class="expand-wrap">
              <!-- 指导老师列表 -->
              <div class="expand-section">
                <div class="expand-title">指导老师</div>
                <el-table
                  v-if="props.row.teachers && props.row.teachers.length"
                  :data="props.row.teachers"
                  border
                  size="mini"
                  style="width: 100%"
                >
                  <el-table-column label="#" type="index" width="60"></el-table-column>
                  <el-table-column label="姓名" prop="userName"></el-table-column>
                  <el-table-column label="性别" prop="sex" :formatter="sexFormat"></el-table-column>
                  <el-table-column label="职位" prop="position"></el-table-column>
                  <el-table-column label="手机号" prop="phone"></el-table-column>
                  <el-table-column label="邮箱" prop="email"></el-table-column>
                </el-table>
                <div v-else class="empty-tip">暂无指导老师信息</div>
              </div>
              <!-- 学生列表 -->
              <div class="expand-section" style="margin-top: 20px">
                <div class="expand-title">学生列表</div>
                <el-table
                  v-if="props.row.students && props.row.students.length"
                  :data="props.row.students"
                  border
                  size="mini"
                  style="width: 100%"
                >
                  <el-table-column label="#" type="index" width="60"></el-table-column>
                  <el-table-column label="姓名" prop="userName"></el-table-column>
                  <el-table-column label="性别" prop="sex" :formatter="sexFormat"></el-table-column>
                  <el-table-column label="年级" prop="grade"></el-table-column>
                  <el-table-column label="手机号" prop="phone"></el-table-column>
                  <el-table-column label="邮箱" prop="email"></el-table-column>
                  <el-table-column label="支付状态" prop="paydStatus">
                    <template slot-scope="scope">
                      <!-- 0-待审核，1-通过，2-驳回 -->
                      <el-tag size="mini" effect="dark" :type="scope.row.paydStatus ? 'primary' : 'danger'">
                        {{ scope.row.paydStatus ? '已支付' : '待支付' }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column label="支付备注" prop="payNote"></el-table-column>
                </el-table>
                <div v-else class="empty-tip">暂无学生信息</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="#" type="index" width="60"></el-table-column>
        <el-table-column label="项目主题" prop="theme"></el-table-column>
        <el-table-column label="项目名称" prop="name"></el-table-column>
        <el-table-column label="项目简介" prop="introduction" show-overflow-tooltip></el-table-column>
        <el-table-column prop="teamName" label="战队名称"></el-table-column>
        <el-table-column label="学校" prop="school.schoolName"></el-table-column>
        <el-table-column label="组别" prop="schoolLevel" :formatter="levelFormat"></el-table-column>
        <el-table-column label="指导老师" prop="sysUser.userName"></el-table-column>
        <el-table-column label="老师数量">
          <template slot-scope="scope">
            {{ scope.row.teachers.length }}
          </template>
        </el-table-column>
        <el-table-column label="选手数量">
          <template slot-scope="scope">
            {{ scope.row.students.length }}
          </template>
        </el-table-column>
        <el-table-column label="手机号" prop="sysUser.phone"></el-table-column>
        <template v-if="!signIn && !isScore">
          <el-table-column label="审核状态" prop="status">
            <template slot-scope="scope">
              <!-- 0-待审核，1-通过，2-驳回 -->
              <el-tag size="mini" :type="scope.row.status === 0 ? 'warning' : scope.row.status === 1 ? 'success' : scope.row.status === 2 ? 'danger' : ''">
                {{ scope.row.status === 0 ? '待审核' : scope.row.status === 1 ? '通过' : scope.row.status === 2 ? '驳回' : '' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="支付状态" prop="paydStatus">
            <template slot-scope="scope">
              <!-- 0-待审核，1-通过，2-驳回 -->
              <el-tag size="mini" effect="dark" :type="scope.row.paydStatus ? 'primary' : 'danger'">
                {{ scope.row.paydStatus ? '已支付' : '待支付' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="支付方式" prop="paydType" :formatter="paydTypeFormat"></el-table-column>
          <el-table-column label="F码" prop="fcode"></el-table-column>
          <el-table-column label="支付凭证">
            <template slot-scope="scope">
              <el-image v-if="scope.row.payImageUrl"
                style="width: 100px; height: 100px"
                :src="scope.row.payImageUrl"
                :preview-src-list="[scope.row.payImageUrl]">
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="payNote" label="支付备注"></el-table-column>
          <el-table-column label="资料审核状态" prop="fileStatus" width="120">
            <template slot-scope="scope">
              <el-tag size="mini" :type="scope.row.fileStatus === 0 ? 'warning' : scope.row.fileStatus === 1 ? 'success' : scope.row.fileStatus === 2 ? 'danger' : 'info'">
                {{ scope.row.fileStatus === 0 ? '待审核' : scope.row.fileStatus === 1 ? '通过' : scope.row.fileStatus === 2 ? '驳回' : '--' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="资料驳回原因" prop="fileRejected" show-overflow-tooltip></el-table-column>
        </template>
        <el-table-column label="签到状态" prop="signStatus" v-if="!isScore">
          <template slot-scope="scope">
            <el-tag size="mini" effect="dark" :type="scope.row.signStatus ? 'success' : 'danger'">
              {{ scope.row.signStatus ? '已签到' : '未签到' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="签到操作" v-if="!isScore">
          <template slot-scope="scope">
            <el-switch
              :value="!!scope.row.signStatus"
              :loading="scope.row.signLoading"
              :disabled="scope.row.signLoading"
              @change="handleSignStatusChange(scope.row, $event)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right" v-if="!signIn && !isScore">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleAudit(scope.row)"
            >报名信息审核</el-button>
            <el-button
              :disabled="!(scope.row.status === 1 && !scope.row.paydStatus)"
              type="text"
              size="small"
              @click="handlePay(scope.row)"
            >确认支付</el-button>
            <el-button
              v-if="scope.row.file"
              type="text"
              size="small"
              @click="previewFile(scope.row)"
            >赛前资料</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right" v-if="isScore">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleToScore(scope.row)"
            >查看成绩</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="margin-top: 15px"
      >
      </el-pagination>
    </el-card>

    <!-- 审核dialog -->
    <el-dialog
      title="报名信息审核"
      :visible.sync="viewDialogVisible"
      width="50%"
    >
      <el-form :model="auditForm" label-width="120px">
        <el-form-item label="审核状态">
          <el-radio-group v-model="auditForm.status">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">驳回</el-radio>
            <el-radio :label="0">待审核</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审核备注" v-if="auditForm.status === 2">
          <el-input
            type="textarea"
            :rows="4"
            v-model="auditForm.rejected"
            placeholder="请输入驳回原因"
          ></el-input>
        </el-form-item>
        <el-form-item label="使用F码">
          <el-checkbox v-model="auditForm.useDiscount"></el-checkbox>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="viewDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="auditLoading" @click="handleAuditSubmit">提交</el-button>
      </span>
    </el-dialog>

    <!-- 查看资料 -->
    <el-dialog
      title="赛前资料"
      :visible.sync="fileVisible"
      width="600px"
    >
      <div>
        <div class="tip">点击文件名下载预览文件</div>
        <div v-for="(item, index) in file" :key="index">
          <div v-if="item.fileUrl" class="file">
            <div class="tit">{{ item.cn }}</div>
            <div class="name" @click="openFn(item.fileUrl)"><img class="icon" src="https://cdn.spbcn.org/spbcnWeb/pbl/icon-file.png" alt="">{{ item.fileName }}</div>
          </div>
        </div>
        <div class="audit">
          <el-form :model="fileForm" label-width="140px">
            <el-form-item label="资料审核状态">
              <el-radio-group v-model="fileForm.fileStatus">
                <el-radio :label="0">待审核</el-radio>
                <el-radio :label="1">通过</el-radio>
                <el-radio :label="2">驳回</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="fileForm.fileStatus === 2" label="驳回原因">
              <el-input
                v-model="fileForm.fileRejected"
                type="textarea"
                :rows="3"
                placeholder="请输入驳回原因"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="fileVisible = false">取消</el-button>
          <el-button type="primary" @click="handleFileStatusSubmit">提交</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 确认支付dialog -->
    <el-dialog
      title="确认支付"
      :visible.sync="payDialogVisible"
      width="50%"
    >
      <el-form :model="payForm" label-width="100px">
        <el-form-item label="支付凭证">
          <el-upload
          class="avatar-uploader"
          :action="
              uploadObj.uploadUrl
          "
          accept="image/*"
          :show-file-list="false"
          :on-success="uploadSuccess"
          :headers="
              uploadObj.headerObj
          "
          :before-upload="beforeUpload"
          :data="{
              filePath:
                  'spbcnWeb/pbl/upload/pay/',
          }"
      >
          <img
              v-if="payForm.payImageUrl"
              class="img-detail"
              :src="payForm.payImageUrl"
          />
          <i
              v-else
              class="el-icon-plus avatar-uploader-icon"
          ></i>
        </el-upload>
        </el-form-item>
        <el-form-item label="支付状态">
          <el-radio-group v-model="payForm.paydStatus">
            <el-radio :label="true">已支付</el-radio>
            <el-radio :label="false">未支付</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            :rows="4"
            v-model="payForm.payNote"
            placeholder="请输入备注信息"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="payDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="payLoading" @click="handlePaySubmit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getPblTeamPage, pblTeamUpdateStatus, pblTeamUpdatePayStatus, pblTeamUpdateFileStatus, pblTeamUpdateSignStatus } from '@/http/api'

export default {
  data () {
    return {
      signIn: this.$route.query.type === 'signin',
      isScore: this.$route.query.type === 'score',
      total: 0,
      queryForm: {
        pageNum: 1,
        pageSize: 10,
        name: '',
        introduction: '',
        status: '',
        paydStatus: '',
        paydType: '',
        fileStatus: '',
        signStatus: ''
      },
      dataList: [],
      viewDialogVisible: false,
      auditForm: {
        id: '',
        status: 1,
        rejected: '',
        useDiscount: false
      },
      auditLoading: false,
      payDialogVisible: false,
      fileVisible: false,
      file: [],
      payForm: {
        id: '',
        paydStatus: true,
        payNote: '',
        payImageUrl: ''
      },
      payLoading: false,
      fileForm: {
        id: '',
        fileStatus: '',
        fileRejected: ''
      },
      uploadObj: {
        uploadUrl: this.$env.baseIP + 'upload/uploadFileAliOss',
        headerObj: {
          Authorization: localStorage.getItem('Authorization')
        }
      }
    }
  },
  created () {
    this.getDataList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    // 获取列表数据
    getDataList (getType) {
      if (getType === 'search') {
        this.queryForm.pageNum = 1
        this.queryForm.pageSize = 10
      }
      getPblTeamPage(this.queryForm).then((res) => {
        console.log('getPblTeamPage', res)
        this.dataList = res.data.list
        this.total = res.data.total
      }).catch((err) => {
        console.log('err', err)
      })
    },
    // 报名信息审核
    handleAudit (row) {
      this.auditForm = {
        id: row.id,
        status: 1,
        rejected: '',
        useDiscount: row.paydType === 4
      }
      this.viewDialogVisible = true
    },
    // 提交审核
    handleAuditSubmit () {
      this.auditLoading = true
      const params = { ...this.auditForm }
      // 选中优惠码支付 -> paydType 传 4；未选中 -> 不传 paydType
      if (params.useDiscount) {
        params.paydType = 4
      }
      delete params.useDiscount
      pblTeamUpdateStatus(params).then((res) => {
        if (res.code === 200) {
          this.$message.success('审核提交成功')
          this.viewDialogVisible = false
          this.getDataList()
        }
        this.auditLoading = false
      }).catch(() => {
        this.auditLoading = false
      })
    },
    // 确认支付
    handlePay (row) {
      this.payForm = {
        id: row.id,
        paydStatus: true,
        payNote: row.payNote,
        payImageUrl: row.payImageUrl
      }
      this.payDialogVisible = true
    },
    // 查看成绩
    handleToScore (row) {
      this.$router.push({
        path: '/b_data_Management/b_matchScoreList',
        query: { id: row.id }
      })
    },
    previewFile (item) {
      this.file = JSON.parse(item.file)
      this.fileForm.id = item.id
      this.fileForm.fileStatus = item.fileStatus !== undefined ? item.fileStatus : ''
      this.fileForm.fileRejected = item.fileRejected || ''
      this.fileVisible = true
    },
    openFn (url) {
      window.open(url)
    },
    // 提交资料审核状态
    handleFileStatusSubmit () {
      pblTeamUpdateFileStatus({
        id: this.fileForm.id,
        fileStatus: this.fileForm.fileStatus,
        fileRejected: this.fileForm.fileRejected
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success('资料审核提交成功')
          this.fileVisible = false
          this.getDataList()
        }
      })
    },
    // 切换战队签到状态
    handleSignStatusChange (row, val) {
      this.$set(row, 'signLoading', true)
      pblTeamUpdateSignStatus({ id: row.id, signStatus: val }).then((res) => {
        if (res.code === 200) {
          this.$message.success(val ? '签到成功' : '已取消签到')
          this.$set(row, 'signStatus', val)
        } else {
          this.$message.error(res.msg || '操作失败')
        }
        this.$set(row, 'signLoading', false)
      }).catch((err) => {
        console.log('err', err)
        this.$set(row, 'signLoading', false)
      })
    },
    // 提交支付
    handlePaySubmit () {
      this.payLoading = true
      pblTeamUpdatePayStatus(this.payForm).then((res) => {
        if (res.code === 200) {
          this.$message.success('支付状态更新成功')
          this.payDialogVisible = false
          this.getDataList()
        }
        this.payLoading = false
      }).catch(() => {
        this.payLoading = false
      })
    },
    // 重置
    reset () {
      this.$refs.queryFormRef.resetFields()
      this.getDataList()
    },
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.getDataList()
    },
    handleCurrentChange (newCurPage) {
      this.queryForm.pageNum = newCurPage
      this.getDataList()
    },
    levelFormat (data) {
      const arr = ['', '小学组', '初中组', '高中组']
      return arr[Number(data.schoolLevel)]
    },
    sexFormat (data) {
      return data.sex === '1' ? '女' : data.sex === '2' ? '男' : '--'
    },
    paydTypeFormat (data) {
      const map = { 1: '统一支付', 2: '队员自行支付', 3: '线下支付', 4: 'F码' }
      return map[data.paydType] || '--'
    },
    beforeUpload (file) {
      const isLt5M = file.size / 1024 / 1024 < 5

      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!')
      }
      return isLt5M
    },
    uploadSuccess (res) {
      this.$set(this.payForm, 'payImageUrl', res.data)
    },
    exportListFn () {
      var downLoadUrl = this.$env.baseIP + 'pblTeam/erpExport'
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl, '', { ...this.queryForm, ...{ pageNum: 1, pageSize: 1000 } })
    },
    exportUserFn () {
      var downLoadUrl = this.$env.baseIP + 'pblTeam/erpExportUsers'
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl, '', { ...this.queryForm, ...{ pageNum: 1, pageSize: 1000 } })
    }
  }
}
</script>

<style lang="less" scoped>
.expand-wrap{
  padding: 10px 20px;
  background-color: #fafafa;
}
.expand-section{
  .expand-title{
    font-size: 14px;
    font-weight: bold;
    color: #4096ff;
    margin-bottom: 10px;
  }
}
.empty-tip{
  color: #999;
  font-size: 13px;
  text-align: center;
  padding: 10px 0;
}
.img-detail{
  max-width: 400px;
}
.tip{
  color: #666;
  font-size: 12px;
  margin-bottom: 30px;
}
.file{
  margin-bottom: 30px;
  .tit{
    font-size: 14px;
    color: #4096ff;
    font-weight: bold;
    // border-bottom: 1px solid #ececec;
    margin-bottom: 16px;
  }
  .name{
    font-size: 14px;
    color: #000;
    display: flex;
    align-items: center;
    cursor: pointer;
    &:hover{
      color: #4096ff;
    }
    img{
      width: 24px;
      margin-right: 8px;
    }
  }
}
.dialog-footer{
  text-align: center;
}
.audit{
  border-top: 1px solid #efefef;
  margin-top: 20px;
  padding-top: 20px;
}
</style>
